import { render } from "./headerFiltersDash.vue?vue&type=template&id=4a7265d8&scoped=true&ts=true"
import script from "./headerFiltersDash.vue?vue&type=script&lang=ts"
export * from "./headerFiltersDash.vue?vue&type=script&lang=ts"

import "./headerFiltersDash.vue?vue&type=style&index=0&id=4a7265d8&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7265d8"]])

export default __exports__